import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class MutationObserverMixin extends Vue {
  observer: MutationObserver;

  addObserver(mutationObserver: ()=> void, mutationElement: HTMLElement = document.body): void {
    this.observer = new MutationObserver(mutationObserver);
    this.observer.observe(mutationElement, {
      attributes: true,
      subtree: true,
      childList: true,
    });
  }

  beforeDestroy(): void {
    this.observer && this.observer.disconnect();
  }
}
